var map = {
	"./202404140935t.mp4": "e155",
	"./AuSaturday_Ad1.png": "ef10",
	"./AuSaturday_Ad2.png": "734e",
	"./EurMillions_Ad1.png": "4d61",
	"./EurMillions_Ad2.png": "adc9",
	"./H5/about.png": "1230",
	"./H5/arrow-1.png": "d2fa",
	"./H5/arrow-2.png": "56e6",
	"./H5/banner.jpg": "7a08",
	"./H5/disclaimer.png": "bc30",
	"./H5/games-1.png": "f5d3",
	"./H5/games-2.png": "de84",
	"./H5/global-1.png": "763d",
	"./H5/global-2.png": "6ab7f",
	"./H5/home-1.png": "4a2f",
	"./H5/home-2.png": "a908",
	"./H5/icons8_memories.png": "26f0",
	"./H5/imageLib-button.png": "93e4",
	"./H5/launch-kl8-website-icon.png": "f6ff",
	"./H5/link.png": "775e",
	"./H5/liveStream.png": "7cec",
	"./H5/liveStreamClose.png": "98ac",
	"./H5/logo.png": "7557",
	"./H5/menu.png": "4328",
	"./H5/news-1.png": "d117",
	"./H5/news-2.png": "6a43",
	"./H5/play-button-close.png": "ab4f",
	"./H5/play-button.png": "8668",
	"./H5/return-1.png": "d49b",
	"./H5/return-2.png": "85ad",
	"./H5/statistics-1.png": "9b01",
	"./H5/statistics-2.png": "b069",
	"./H5/statistics.png": "2e63",
	"./H5/top_bg.jpg": "b08d",
	"./H5/user-1.png": "bba0",
	"./H5/user-2.png": "da26",
	"./H5/volume.png": "878f",
	"./UsSuperMillions_Ad1.png": "96f5",
	"./UsSuperMillions_Ad2.png": "6db5",
	"./about.png": "ce1b",
	"./ad1.png": "5e33",
	"./ad2.png": "d44b",
	"./ad3.png": "a9a7",
	"./allow_icon.jpg": "0d64",
	"./ballIcon/Pl3_icon.png": "6581",
	"./ballIcon/Pl5_icon.png": "3c8e",
	"./ballIcon/USMegaMillions.png": "2ea8",
	"./ballIcon/USPowerBall.png": "13c6",
	"./ballIcon/auSaturdayLotto_icon.png": "0cb7",
	"./ballIcon/azxy10_icon.png": "6984",
	"./ballIcon/azxy20.png": "8c43",
	"./ballIcon/azxy5_icon.png": "67bb",
	"./ballIcon/azxy8_icon.png": "68fe",
	"./ballIcon/cannon20_icon.png": "bb4e",
	"./ballIcon/cannon20ex_icon.png": "3468",
	"./ballIcon/euroMillions_icon.png": "fc0e",
	"./ballIcon/gamma3_icon.png": "a7c1",
	"./ballIcon/gamma3ex_icon.png": "71aa",
	"./ballIcon/hklhc_icon.png": "c543",
	"./ballIcon/infinity8_icon.png": "0f39",
	"./ballIcon/infinity8ex_icon.png": "7fb1",
	"./ballIcon/jisukuai3_icon.png": "319e",
	"./ballIcon/jisukuaile_icon.png": "ef5c",
	"./ballIcon/jisusaiche_icon.png": "a2c2",
	"./ballIcon/jisushishi_icon.png": "9e1a",
	"./ballIcon/kl8lhc_icon.png": "37f4",
	"./ballIcon/lucky5_icon.png": "5d6a",
	"./ballIcon/lucky5ex_icon.png": "44db",
	"./ballIcon/lucky7daily_icon.png": "c6a8",
	"./ballIcon/pailie3_icon.png": "d3e1",
	"./ballIcon/pailie5_icon.png": "82be",
	"./ballIcon/penta5_icon.png": "4f9d",
	"./ballIcon/penta5classic_icon.png": "d24b",
	"./ballIcon/penta5ex_icon.png": "e3b4",
	"./ballIcon/penta_icon.png": "63fa",
	"./ballIcon/pl5daily_icon.png": "a710",
	"./ballIcon/qxc_icon.png": "6095",
	"./ballIcon/rolling10_icon.png": "3e35",
	"./ballIcon/rolling10ex_icon.png": "3f6c",
	"./ballIcon/sgplhc_icon.png": "cf82",
	"./ballIcon/surfing10classic_icon.png": "43ef",
	"./ballIcon/twlhc_icon.png": "6ce0",
	"./ballIcon/usMegaMillions_icon.png": "755b",
	"./ballIcon/usPowerBall_icon.png": "295f",
	"./banner.png": "f0692",
	"./banner_home-o.jpg": "4644",
	"./banner_home.jpg": "cb26",
	"./bn.jpg": "2da0",
	"./car_icon.png": "132d",
	"./disclaimer.png": "b889",
	"./global.png": "6352",
	"./hamburger.svg": "9bd3",
	"./history_icon.svg": "63fb",
	"./home.png": "4a31",
	"./home_lottery_type1.png": "2231",
	"./home_lottery_type2.png": "e741",
	"./home_lottery_type3.png": "07ed",
	"./home_lottery_type4.png": "6618",
	"./home_lottery_type5.png": "4168",
	"./home_lottery_type6.png": "5565",
	"./hot.png": "0480",
	"./hotAndCode.svg": "b608",
	"./ico_close_gray.png": "03a4",
	"./icon_lottery.png": "19af",
	"./list-1.png": "dd18",
	"./list-2.png": "a4fc",
	"./live_big_icon.png": "909a",
	"./live_big_icon_open.png": "512d",
	"./live_btn.png": "3d59",
	"./livebtn.svg": "495b",
	"./logo.png": "7c04",
	"./logo_footer.png": "ed5a",
	"./looter_bg.png": "b45c",
	"./lotteryType.png": "8a39",
	"./medals.png": "f439",
	"./menu_down.svg": "d40b",
	"./menu_up.svg": "63d4",
	"./mobile_banner.jpg": "48e4",
	"./mobile_popup.png": "cc4c",
	"./navBar.png": "64d5",
	"./new_img.png": "a297",
	"./notify_icon.svg": "385f",
	"./pc_banner.jpg": "712d",
	"./pc_banner_gradient.jpg": "d033",
	"./pc_popup.png": "a267",
	"./play-button.png": "c63d",
	"./powerBallAd1.png": "e34a",
	"./powerBallAd2.png": "b8bb",
	"./return-1.png": "2d0e",
	"./return-2.png": "75b5",
	"./ribbon.svg": "05f7",
	"./rightArrow.svg": "491d",
	"./rules.png": "1c03",
	"./star.png": "1596",
	"./sticky.png": "2903",
	"./test/newsImg.png": "59cf",
	"./zhibo-bg.png": "5040"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";